
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  Attachment,
  AttachmentTypeOptions,
  PermissionCode,
} from '@/types';
import { currentUserHasPermission } from '@/helpers';

@Component
export default class AttachmentTypeDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Object) readonly attachment!: Attachment;

  // Se true, è utilizzato all'interno di una Connection
  @Prop({ type: Boolean, default: false }) readonly connection!: boolean

  dialog = false
  loading = false
  attachmentType: string | null = null

  // Tipologie di allegati disponibili per il tipo di Lead selezionato
  @Watch('lead')
  attachmentTypesForLeadType() {
    if (!this.lead) return {};

    const details = this.$store.getters.attachmentsDetails;

    const types = Object.keys(details);
    const allowedTypes = {};

    types.forEach((item) => {
      if (details[item].leadTypes.includes(this.lead.type)) {
        allowedTypes[item] = details[item].description;
      }
    });
    return allowedTypes;
  }

  get attachmentTypes() {
    const entries = this.attachmentTypesForLeadType();
    return Object.entries(entries)
      .map((option) => ({ value: option[0], text: option[1] }))
      .filter((option) => (
        this.hasPermission(`attachments.${option.value}.read`)
        && this.hasPermission(`attachments.${option.value}.add`)
      ));
  }

  get attachmentTypeOption(): string {
    return this.attachment && this.attachment.fieldname in AttachmentTypeOptions
      ? AttachmentTypeOptions[this.attachment.fieldname] : 'Sconosciuto';
  }

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    this.attachmentType = this.attachment && this.attachment.fieldname in AttachmentTypeOptions
      ? this.attachment.fieldname
      : 'null';
  }

  hasPermission(codename: PermissionCode) { return currentUserHasPermission(codename); }

  @Watch('value')
  onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange()`); // eslint-disable-line no-console

    this.dialog = val;

    if (val) {
      // Inizializza tutti i campi del modulo
      this.refresh();
    }
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  onFieldUpdated(field: string, value: unknown = undefined) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    // Se è stato specificato un valore, lo assegno
    if (value !== undefined) this[field] = value;
  }

  async onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onConfirm() {
    console.log(`${this.constructor.name}: onConfirm()`); // eslint-disable-line no-console

    this.loading = true;

    this.$emit('changeType', this.attachment.id, this.attachmentType);

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
